import { render, staticRenderFns } from "./WhiteBoard.vue?vue&type=template&id=5cba4198&scoped=true"
import script from "./WhiteBoard.vue?vue&type=script&lang=js"
export * from "./WhiteBoard.vue?vue&type=script&lang=js"
import style0 from "./WhiteBoard.vue?vue&type=style&index=0&id=5cba4198&prod&scoped=true&lang=css"
import style1 from "./WhiteBoard.vue?vue&type=style&index=1&id=5cba4198&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cba4198",
  null
  
)

export default component.exports